import { render, staticRenderFns } from "./EmailReminderForm.vue?vue&type=template&id=af59dd46&"
import script from "./EmailReminderForm.vue?vue&type=script&lang=js&"
export * from "./EmailReminderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports